import { Route } from 'react-router-dom';
import PageOutgoing from '../../pages/raptor/routes/outgoing/outgoing.page';
import PageIncomming from '../../pages/raptor/routes/incomming/incomming.page';

export const RaptorRoutes = (
  <>
    <Route path="/routes-outgoing">
      <Route index element={<PageOutgoing />} />
    </Route>
    <Route path="/routes-incomming">
      <Route index element={<PageIncomming />} />
    </Route>
  </>
);
